<template>
  <div class="mainpage h-100 container-fluid p-0 m-0" >
        <!-- HEADER -->
        <Header/>

        <div v-if="!showQuestions"  id="stage-1" class="page welcome-page col mt-5">
                <div class="text-center col-sm-10 col-md-8 col-lg-6 m-auto">
                            <h2>
                                    Live in <b>Greater Manchester?</b> <br>Interested in accents and dialects?
                            </h2>
        
                            <h4 class="my-5">
                                    Draw your own dialect map of the region!
                            </h4>
                            <p>
                                    At the Manchester Voices project, we’re interested in finding out where you think people speak differently from each other, and how you name, describe and give examples of the accents and dialects of the region.
                            </p>
                            <p>
                                    Click ‘begin’ below to start creating your dialect map. We’ll ask for some basic information about you first, then we’ll take you to the draw-a-map page.
                            </p>

                </div>
                <div class="col text-center my-5">
                  <button v-on:click="showQuestionaire()" type="button" id="btnBegin" class="btn px-5">Begin</button>
                </div>
        </div>
        <div v-else class="question-holder">
            <Questionaire :showQuestions.sync="showQuestions" />  
        </div>

        
        <div class="p-0 py-5 copyright-tag flex-column"  v-if="!showQuestions">
          <div class="col-sm-10 col-md-8 col-lg-6 m-auto consent-copy">
              <p>
By submitting your map, you are consenting to your data being used to create dialect maps of Greater Manchester which will be displayed in public exhibitions and academic publications. We’ll also make your data available to other academic researchers upon request. We won't ask for your name, and your data will be treated confidentially and stored securely.              </p>                  
              <p>The Manchester Voices project is funded by the Arts and Humanities Research Council (Reference: AH/S006125/1) and has obtained full ethical approval from Manchester Metropolitan University (EthOS Reference Number: 10639, Version: 2, Date: 23/08/19).</p>
              <p>
                      For any questions or concerns, email us at <u><a class="yellow-text" href="mailto:e.carrie@mmu.ac.uk">e.carrie@mmu.ac.uk</a></u> and <u><a class="yellow-text" href="mailto:r.drummond@mmu.ac.uk">r.drummond@mmu.ac.uk</a></u>
              </p>
              </div>
        </div>
    </div>
</template>

<style scoped>

.consent-copy{
  font-size: 0.8rem;
}
.welcome-page{
  color: #2B2B2B;
}
.question-holder{
     background-color:#757575;
}
.header-holder{
  /* padding-top: 20px; */
  /* margin-bottom: 50px !important; */
    /* min-height: 150px; */
     /* background-color: rgb(133, 133, 133); */
}

.yellow-text{
    color: rgb(229, 192, 16);
}

.white-text{
    color: rgb(255, 255, 255);
}
#btnBegin{
  border-radius: 100px;
  border: 1px solid rgb(255, 255, 255);
  background-color: rgb(229, 192, 16);
}
.copyright-tag{
     background-color: rgba(0, 0, 0, 0.5);
     /* position: relative;
     bottom: 0px; */
     /* bottom: 100px; */
}
.mainpage{
  color: white;
    /* height: 100%; */
    /* min-height: 100vh; */
}

</style>


<script>
// @ is an alias to /src
import Questionaire from "@/components/Questionaire.vue";
import Header from "@/components/Header.vue";
var mapImage = require('@/assets/map.png');

export default {
  name: "home",
  components: {
    Questionaire,
    Header
  },
  data (){
    return{
      showQuestions : false,
    }
  },methods :{
    showQuestionaire (){
      this.showQuestions = true;
    }
  }
};
</script>
